import { IFieldLangMap } from '@pharmsnap/shared/types'

export const CT_DATA_SOURCE_LANG: IFieldLangMap = {
  CTR: { en: 'CTR', jp: 'CTR', cn: 'CTR' },
  CTGOV: { en: 'ClinicalTrials.gov', jp: 'ClinicalTrials.gov', cn: 'ClinicalTrials.gov' },
  WHO: { en: 'WHO', jp: 'WHO', cn: 'WHO' },
  ChiCTR: { en: 'ChiCTR', jp: 'ChiCTR', cn: 'ChiCTR' },
  CTIS: { en: 'CTIS', jp: 'CTIS', cn: 'CTIS' },
}

export const CT_SINGLE_MULTI_CENTER_LANG: IFieldLangMap = {
  UNKNOWN: { en: 'Unknown', jp: '不明', cn: '未知' },
  SINGLE: { en: 'Single', jp: '単施設', cn: '单中心' },
  MULTI: { en: 'Multi', jp: '多施設', cn: '多中心' },
}

export const CT_IF_RESULT_LANG: IFieldLangMap = {
  0: { en: 'No', jp: 'なし', cn: '无' },
  1: { en: 'Yes', jp: 'あり', cn: '有' },
}

export const CT_IIT_LANG: IFieldLangMap = {
  0: { en: 'No', jp: 'なし', cn: '否' },
  1: { en: 'Yes', jp: 'あり', cn: '是' },
}

export const SPONSOR_FUNDER_TYPE_LANG: IFieldLangMap = {
  'All others (individuals, universities, organizations)': {
    en: 'All others (individuals, universities, organizations)',
    jp: 'その他（個人、大学、団体）',
    cn: '其他（个人，大学，组织）',
  },
  Industry: {
    en: 'Industry',
    jp: '企業',
    cn: '企业',
  },
  NIH: {
    en: 'NIH',
    jp: 'NIH',
    cn: 'NIH',
  },
  'Other U.S. Federal agency': {
    en: 'Other U.S. Federal agency',
    jp: 'その他の米国連邦機関',
    cn: '其他美国联邦机构',
  },
}

export const SINGLE_OR_MULTI_DRUG_LANG: IFieldLangMap = {
  MULTIPLE_DRUGS: {
    cn: '联合',
    en: 'Combo',
    jp: '併用',
  },
  SINGLE_DRUG: {
    cn: '单药',
    en: 'Mono',
    jp: '単剤',
  },
  'N/A': {
    cn: 'N/A',
    en: 'N/A',
    jp: 'N/A',
  },
}
